export default __webpack_public_path__ + "static/media/dahyun.f6d6912c.jpg";